type InstallEvent=Event&{prompt:()=>Promise<void>;userChoice:Promise<{outcome:'accepted'|'dismissed'}>};
let deferred:InstallEvent|null=null,initialized=false,installedHere=false;
const dismissKey='sonata-install-dismissed-until';
let dismissedUntil=0;
const notify=()=>window.dispatchEvent(new Event('sonata-install-state'));
export const installPlatform=()=>/iPhone|iPad|iPod/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1)?'ios':/Android/i.test(navigator.userAgent)?'android':null;
export const appIsInstalled=()=>installedHere||window.matchMedia('(display-mode: standalone)').matches||(navigator as Navigator&{standalone?:boolean}).standalone===true;
export const nativeInstallAvailable=()=>!!deferred&&!appIsInstalled();
export function installDismissed(now=Date.now()){
 try{dismissedUntil=Math.max(dismissedUntil,Number(localStorage.getItem(dismissKey))||0);}catch{}
 return dismissedUntil>now;
}
export function dismissInstall(){
 dismissedUntil=Date.now()+7*86400000;
 try{localStorage.setItem(dismissKey,String(dismissedUntil));}catch{}
 notify();
}
export function initializeAppInstall(){
 if(initialized)return;initialized=true;
 window.addEventListener('beforeinstallprompt',event=>{event.preventDefault();deferred=event as InstallEvent;notify();});
 window.addEventListener('appinstalled',()=>{installedHere=true;deferred=null;notify();});
 window.matchMedia('(display-mode: standalone)').addEventListener('change',notify);
}
export async function installApp(){
 const event=deferred;if(!event||appIsInstalled())throw new Error('Use your browser’s menu to add Sonata Fields to your Home Screen.');
 deferred=null;notify();
 // Invoke directly from the user's click, before any await/network work.
 await event.prompt();const choice=await event.userChoice;
 dismissInstall();return choice.outcome;
}
export const openInstallGuide=()=>window.dispatchEvent(new Event('sonata-open-install-guide'));
